//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    error: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    message: function () {
      return this.error?.message || "";
    },
    statusCode: function () {
      return this.error?.statusCode || "404";
    },
  }
}
